<section>
    <!-- top  -->
    <section id="s-checkin" *ngIf="!isRefSPay">
        <div class="w-100 bgblue text-center py-3">
            <div class="container py-2">
                <div class="row">
                    <div class="col-12 text-center">
                        <img alt="Brand" src="assets/img/logo.svg" class="img img-fluid">
                    </div>

                </div>
            </div>
        </div>
    </section>
    <!-- end top -->
    <section>
        <div class="bgmain content pb-4">
            <div class="container" *ngIf="idx==0">
                <div class="row">
                    <div class="col-lg-12 mb-4 mt-5">
                        <div class="text-highlight text-center pt-3">Quý khách vui lòng bật định vị trên
                            điện thoại để lấy STT</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-result text-center"><img src="assets/img/turngps.png" alt="icon"
                                class="img-fluid"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center mt-4">
                        <div id="myDIV_dot" class="text-center">
                            <a class="btn btn-dot" [ngClass]="idx==0 ? 'active-dot' : ''" (click)="ChangeIdx(0)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==1 ? 'active-dot' : ''" (click)="ChangeIdx(1)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==2 ? 'active-dot' : ''" (click)="ChangeIdx(2)"></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" *ngIf="idx==1">
                <div class="row">
                    <div class="col-lg-12 mb-2 mt-3">
                        <div class="text-guide text-center">Hướng dẫn trên iOS</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4">
                        <div class="text-highlight text-center">Cài đặt <span>></span> Quyền riêng tư:
                            <p class="text-left m-0 mt-2">- Dịch vụ định vị <span>></span> Bật</p>
                            <p class="text-left m-0">- Trình duyệt web, SACOMBANK PAY, Zalo <span>></span> Chọn khi dùng ứng dụng</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-result text-center"><img src="assets/img/ip.png" alt="icon" class="img-fluid">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center mt-2">
                        <div id="myDIV_dot" class="text-center">
                            <a class="btn btn-dot" [ngClass]="idx==0 ? 'active-dot' : ''" (click)="ChangeIdx(0)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==1 ? 'active-dot' : ''" (click)="ChangeIdx(1)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==2 ? 'active-dot' : ''" (click)="ChangeIdx(2)"></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" *ngIf="idx==2">
                <div class="row">
                    <div class="col-lg-12 mb-2 mt-3">
                        <div class="text-guide text-center">Hướng dẫn trên Android</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4">
                        <div class="text-highlight text-center">Cài đặt <span>></span> Vị trí:
                            <p class="text-left m-0 mt-2">- Quyền của ứng dụng <span>></span> Bật</p>
                            <p class="text-left m-0">- Trình duyệt web, SACOMBANK PAY, Zalo <span>></span> Cho phép khi dùng ứng dụng</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-result text-center"><img src="assets/img/android.png" alt="icon"
                                class="img-fluid">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center mt-2">
                        <div id="myDIV_dot" class="text-center">
                            <a class="btn btn-dot" [ngClass]="idx==0 ? 'active-dot' : ''" (click)="ChangeIdx(0)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==1 ? 'active-dot' : ''" (click)="ChangeIdx(1)"></a>
                            <a class="btn btn-dot" [ngClass]="idx==2 ? 'active-dot' : ''" (click)="ChangeIdx(2)"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>